export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/weWingmanWorker.worker.ee10fa5e.worker.js");
}
